/**
 * 認証の純関数（PF34 Bearer・node テスト可能）— Phase 2 / Slice 5
 * -----------------------------------------------------------------------------
 * Ray of Ray ID のマジックリンク認証（rayofray-auth-billing）を PWA へ移植。
 * IO（fetch/localStorage/signal）は session.ts 側に置き、ここは形の変換と規則だけ。
 *
 * 鉄則（スキル準拠）:
 *  - sessionToken は保存キー1つ（localStorage）だけに置く・ログ/コメントに出さない。
 *  - 401/unauthorized を受けたらトークンを破棄してログイン UI へ戻す。
 */

/** localStorage の保存キー（sessionToken）。 */
export const SESSION_KEY = "sheetsnap:session";
/** マジックリンクのメール文面ブランド分岐に使う app 識別子（バックエンド登録が前提）。 */
export const APP_ID = "sheetsnap";

/** /auth/verify のレスポンス → 保存する session 形。トークン欠落は例外。 */
export function sessionFromVerify(resp) {
  const token = resp?.sessionToken;
  if (!token || typeof token !== "string") throw new Error("トークンの交換に失敗しました");
  return { token, user: resp.user ?? null };
}

/**
 * データ API へ付与する認証ヘッダを組み立てる（Bearer 優先・ローカルは X-Dev-User）。
 * @param {{ token?: string, devUser?: string }} [opts]
 * @returns {Record<string, string>}
 */
export function buildAuthHeaders({ token, devUser } = {}) {
  /** @type {Record<string, string>} */
  const h = {};
  if (token) h["Authorization"] = `Bearer ${token}`;
  else if (devUser) h["X-Dev-User"] = String(devUser); // DEV_MODE のときだけサーバが受理
  return h;
}

/** ログイン必須か（本番）を判定する。token も devUser も無ければ要ログイン。 */
export function needsLogin({ token, devUser } = {}) {
  return !token && !devUser;
}

/** メールの最小バリデーション（送信ボタンの活性判定用）。 */
export function isValidEmail(email) {
  return typeof email === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
